export default __webpack_public_path__ + "static/media/newtwo.4ea85c80.png";